<template>
	<div class="dropdown d-block d-sm-none">
    <template>
      <li class="nav-item dropdown" style="display: block">
        <a href="#"
           id="languageDropdown"
           class="d-flex align-items-center nav-link dropdown-toggle"
           data-toggle="dropdown"
           aria-expanded="false">
          <img v-bind:src="getFlag(userLanguage)" alt="" class="fiCircle">
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown language-dropdown"
             aria-labelledby="languageDropdown">
          <a
              class="dropdown-item"
              v-for="(item, index) in languageList"
              :href="item.url"
              :key="index"
              @click.prevent="setLocale(item.key)"
          >
            <div class="d-flex align-items-center justify-content-center">
              <h6 class="mb-0 font-weight-normal">{{ $t(item.title) }}</h6>
            </div>
          </a>

          <a class="dropdown-item" :href="urlGenerator('/admin/users/login ')">
            <app-icon :name="`${loggedIn ? 'columns' : 'log-in' }`" class="size-15 text-muted mr-2" />
            <span>
            		{{ loggedIn ? $t('dashboard') : $t('login')}}
				</span>
          </a>
        </div>
      </li>
    </template>
	</div>
</template>

<script>
import { urlGenerator } from '../../../Helpers/AxiosHelper';
import {LANG} from "../../../Config/ApiUrl";
import {FormMixin} from "../../../../core/mixins/form/FormMixin";
export default {
  mixins: [FormMixin],
	name:"HeroDropdown",
	data() {
		return {
			urlGenerator
		}
	},
	props: {
		loggedIn: {
			required: true,
			type: Boolean
		}
	},
  methods: {
    setLocale(lang) {
      this.axiosPost({
        url: LANG,
        data: {
          lang: lang,
        },
      }).then(() => {
        window.location.reload();
      });
    },
    getFlag(flag){
      return '/images/'+ flag +'.png';
    }
  },
  created() {
    this.$store.dispatch('getSettings');
    this.$store.dispatch('getNotifications');
    this.$store.dispatch('setSelectedLanguage');
    this.$store.dispatch('getUser');
    this.$store.dispatch('getLanguages');
  },
  computed: {
    userLanguage() {
      return window.localStorage.getItem('app-language').toUpperCase()
    },
    languageList() {
      return this.$store.state.settings.languages;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
